<template>
  <!-- add more -->
  <div class="flies-step add-flies">
    <div class="d-flex align-items-center mb-2">
      <label class="d-inline-block mr-3 mb-0 cursor-pointer">
        <i class="icon-style icon-ms style-add-full"></i>
        <input
          type="file"
          id="add-file"
          multiple="multiple"
          hidden="hidden"
          @change="uploadFiles"
        />
      </label>
      <div>
        <h5 class="mb-1">Add more</h5>
        <div class="small">
          Total {{ filesInfo.total_num }} files,
          {{ fileLengthFormat(filesInfo.total_size) }}
        </div>
      </div>
    </div>
    <div class="files-list rounded border bg-light p-2">
      <div
        v-for="(file, index) in filesInfo.files"
        :key="index"
        class="list d-flex justify-content-between"
      >
        <span>{{ file.name }}</span>
        <div class="operate">
          <a href="javascript:void(0)">
            <span class="size">{{ fileLengthFormat(file.size) }}</span>
          </a>
          <a
            href="javascript:void(0)"
            class="btn-delete"
            @click="deleteFile(index)"
            ><i class="icon-img icon-xxs img-delete"></i
          ></a>
        </div>
      </div>
    </div>
    <div class="pt-3">
      <a
        href="javascript:void(0)"
        :class="['btn-send', 'd-block', { disabled: isLoading }]"
        @click="createKey()"
      >
        <span>Send</span>
        <i class="loader"></i>
      </a>
    </div>
  </div>
</template>

<script>
import {
  fileLengthFormat,
  getFileType,
  stringToHex
} from "../../../utils/Helpers";
import md5 from "js-md5";
import request from "../../../utils/Request";
import swal from "sweetalert";

export default {
  name: "MyFileList",
  data() {
    return {
      isLoading: false
    };
  },
  model: {
    prop: "transfer"
  },
  props: ["transfer"],
  computed: {
    filesInfo() {
      // 这里计算属性直接返回filesInfo，而不是filesInfo下的属性是因为total_size和total_num的改变无法触发更新事件
      return this.transfer.filesInfo;
    }
  },
  methods: {
    fileLengthFormat(size) {
      return fileLengthFormat(size);
    },
    uploadFiles(event) {
      let files = event.target.files;
      for (let i = 0, len = files.length; i < len; i++) {
        this.transfer.files.push(files[i]);
        this.transfer.filesInfo.files.push({
          key: md5(files[i].name),
          name: files[i].name,
          size: files[i].size,
          type: getFileType(files[i].type, files[i].name),
          modified: files[i].lastModified
        });
        this.transfer.filesInfo.total_size += files[i].size;
      }
      this.transfer.filesInfo.total_num += files.length;
    },
    createKey() {
      if (
        //单次传输大小限制判断
        this.transfer.filesInfo.total_size >
        this.$store.getters.singleTransferSize
      ) {
        swal(
          "Cannot transfer over " +
            fileLengthFormat(this.$store.getters.singleTransferSize) +
            " of files at a time."
        );
        return;
      }
      if (
        //单次传输大小限制判断
        this.transfer.filesInfo.total_num >
        parseInt(this.$store.state.configs["PB:SINGLE_TRANSFER_NUMBER"])
      ) {
        swal(
          "Cannot transfer over " +
            this.$store.state.configs["PB:SINGLE_TRANSFER_NUMBER"] +
            " files at a time."
        );
        return;
      }
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      request({
        url: "/v1/transfer/create",
        data: {
          transfer_type: 1,
          files_mark: getFileType(
            this.transfer.files[0].type,
            this.transfer.files[0].name
          ),
          upload_client_name: this.$store.getters.nickname,
          file_list: stringToHex(JSON.stringify(this.transfer.filesInfo))
        }
      })
        .then(response => {
          if (response.code === 200) {
            // 这里改变transfer变量可能报错
            $.extend(this.transfer, response.data);
            this.transfer.step = 3;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    deleteFile(index) {
      this.transfer.filesInfo.total_size -= this.transfer.files[index].size;
      this.transfer.filesInfo.total_num--;
      this.transfer.filesInfo.files.splice(index, 1);
      this.transfer.files.splice(index, 1);

      if (this.transfer.files.length <= 0) {
        this.transfer.step = 1;
      }
    }
  }
};
</script>
